<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page class="distributor-subordinate-page">
        <!-- 表单区 -->

        <!-- 内容 -->
        <ECharts
            ref="charts"
            class="body echarts-demo"
            slot="body"
            v-loading="querying"
            :options="chartsOptions"
            @click="onChartsClick"
        >
            <!-- 操作 -->
            <!-- 表格 -->
            <!-- 分页 -->
        </ECharts>
        <!--<div v-else>无数据</div>-->
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';

export default {
    name: 'Distributor',
    mixins: [pagesMixin],
    data() {
        return {
            querying: false,
            subordinateList: [],
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        subordinateMap() {
            return this.subordinateList.reduce((p, c) => ((p[c.id] = c), p), {});
        },
        subordinateData() {
            const res = [];
            const { subordinateMap } = this;
            this.subordinateList.forEach(item => {
                const { referenceId, levelNum } = item;
                if (!levelNum) {
                    res.push(item);
                } else {
                    const parent = subordinateMap[referenceId];
                    if (!parent) {
                        console.error('此节点数据有问题', item);
                    } else {
                        const children = (parent.children = parent.children || []);
                        children.push(item);
                    }
                }
            });
            return res;
        },
        chartsOptions() {
            return {
                tooltip: {
                    trigger: 'item',
                    triggerOn: 'mousemove',
                },
                series: [
                    {
                        type: 'tree',

                        // data: [data1],
                        data: this.subordinateData,

                        // top: '1%',
                        left: '20%',
                        // bottom: '1%',
                        right: '20%',

                        symbolSize: 30,

                        label: {
                            normal: {
                                position: 'left',
                                verticalAlign: 'middle',
                                align: 'right',
                                fontSize: 14,
                                formatter: '{name|{b}}\n{c}',
                                backgroundColor: '#dee2e6',
                                borderRadius: 5,
                                padding: [5, 10],
                                rich: {
                                    name: {
                                        fontSize: 18,
                                        color: '#000',
                                        // lineHeight: 10,
                                        // borderColor: '#449933',
                                        borderRadius: 4,
                                    },
                                },
                            },
                        },

                        leaves: {
                            label: {
                                normal: {
                                    position: 'right',
                                    verticalAlign: 'middle',
                                    align: 'left',
                                },
                            },
                        },

                        roam: true,
                        expandAndCollapse: false,
                        initialTreeDepth: -1,
                        animationDuration: 550,
                        animationDurationUpdate: 750,
                    },
                ],
            };
        },
    },
    methods: {
        /* -- 方法 -- */
        getDistributorSubordinateList() {
            this.querying = true;
            this.$api.Mb.Distributor.getDistributorSubordinateList({
                id: this.id,
            })
                .then(json => {
                    const res = json.data.data;
                    this.subordinateList = res.map(item => ({
                        ...item,
                        name: item.distributorName,
                        value: `+${item.distributorCountryCode}-${item.distributorTel}`,
                        symbol: item.levelIconUrl
                            ? `image://${item.levelIconUrl}`
                            : 'image://http://img.goefresh.com/upload/shop/C20AD4D76FE97759AA27A0C99BFF6710/buyerLevel/b92b3cf537934258b777e42f283bd428.png@200w',
                    }));
                })
                .finally(() => {
                    this.querying = false;
                });
        },
        /* -- 事件 -- */
        onChartsClick($event, a, b) {
            console.log($event, a, b);
        },
    },
    created() {
        this.getDistributorSubordinateList();
    },
};
</script>

<style lang="scss" scoped>
.echarts-demo {
    width: 100%;
}
</style>
<style lang="scss">
.distributor-subordinate-page {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    > .header {
        flex: 0 0 auto;
    }
    > .body {
        flex: 1 1 1%;
    }
}
</style>
